import React from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import Select from './Select';
import { InputPropType, SelectDataPropType } from '../../proptypes/input';
import { ApiErrorPropType } from '../../proptypes/errors';
import { useIsFranchise,useGetUserEmplyeeId } from '../../Modules/abilities/hooks';
import { selectEmployeesById } from '../../Modules/employees/employeesSlice';

const tools = require('helpers/tools');

const LocationSelect = ({
    input: { value, onChange, name },
    disabled,
    data,
    error,
    extra,
    showAll,
}) => {

    const isFranchise = useIsFranchise();
    const employees = useSelector(selectEmployeesById);
    const empId = useGetUserEmplyeeId();
    const active_user_employee = employees[empId];

    if (error || !data) {
        return <div className="alert alert-danger">Fehler beim Laden der Standorte</div>;
    }

    const merged = [...data, ...extra].filter(location => {
        if (isFranchise && active_user_employee) {
            // For franchise users, show all locations if showAll is true, otherwise only their own location.
            return showAll || location.id === active_user_employee.locationId;
        } else {
            // For other users, show all or only active locations.
            return showAll || !location.status || location.status === 'active';
        }
    });

    if (value && tools.findObjectInArrayById(merged, parseInt(value, 10)) === false) {
        // TODO: Möglichkeit anbieten, per Klick die Entities neu abzurufen
        return (
            <div className="alert alert-danger">
                Der Standort mit der ID {value} konnte nicht gefunden werden!
            </div>
        );
    }

    return (
        <Select
            onChange={onChange}
            value={value}
            data={merged}
            renderValue={item => (item ? item.matchCode : '')}
            name={name}
            disabled={disabled}
        />
    );
};

LocationSelect.propTypes = {
    input: InputPropType.isRequired,
    data: SelectDataPropType,
    error: ApiErrorPropType,
    disabled: PropTypes.bool,
    extra: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string,
            isDivider: PropTypes.bool,
        })
    ),
    showAll: PropTypes.bool,
};

LocationSelect.defaultProps = {
    data: null,
    error: null,
    disabled: false,
    extra: [],
    showAll: false,
};

export default connect(state => ({
    data: state.location.entities,
    error: state.location.error,
}))(LocationSelect);
